import { render, staticRenderFns } from "./IntegrationWidget.vue?vue&type=template&id=686eaf9c"
import script from "./IntegrationWidget.vue?vue&type=script&lang=js"
export * from "./IntegrationWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports